import React from "react";

export const defaultModelId = (modelFamilies) => {
    const first = Object.values(modelFamilies || {})[0];
    return first?.versions?.[0]?.id || "";
};

const ModelVersionSelect = ({ modelFamilies, value, onChange, disabled }) => {
    const families = Object.entries(modelFamilies || {});
    const currentFamilyKey =
        families.find(([, family]) => family.versions?.some(v => v.id === value))?.[0] ||
        families[0]?.[0] ||
        "";
    const currentVersions = modelFamilies?.[currentFamilyKey]?.versions || [];

    const handleFamilyChange = (familyKey) => {
        const versions = modelFamilies?.[familyKey]?.versions || [];
        if (versions[0]) onChange(versions[0].id);
    };

    return (
        <div className="model-version-select">
            <select
                className="admin-form-input"
                value={currentFamilyKey}
                disabled={disabled}
                onChange={(e) => handleFamilyChange(e.target.value)}
            >
                {families.map(([key, family]) => (
                    <option key={key} value={key}>{family.label}</option>
                ))}
            </select>
            <select
                className="admin-form-input"
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
            >
                {currentVersions.map(v => (
                    <option key={v.id} value={v.id}>{v.label}</option>
                ))}
            </select>
        </div>
    );
};

export default ModelVersionSelect;
